<template>
  <div class="app">
    <router-view />
  </div>
</template>

<script setup>
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
  background: #0a0a0a;
  color: #e0e0e0;
  min-width: 0;
  overflow-x: hidden;
}

.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

@media (max-width: 980px) {
  .studio-backdrop.embedded {
    padding-bottom: calc(var(--app-bottom-nav-space, 58px) + env(safe-area-inset-bottom));
  }

  .studio-backdrop.embedded .studio {
    height: 100%;
    max-height: 100%;
  }

  .studio-backdrop.embedded .actions {
    position: sticky;
    bottom: 0;
    z-index: 4;
    padding: 6px 0 2px;
    background: #111;
  }
}
</style>
